import "@/App.css";
import { SiteProvider } from "@/context/SiteContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import FloatingPortalButton from "@/components/FloatingPortalButton";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import About from "@/components/sections/About";
import Certificates from "@/components/sections/Certificates";
import ServiceAreas from "@/components/sections/ServiceAreas";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

function App() {
  return (
    <SiteProvider>
      <SmoothScroll>
        <div className="App bg-background text-foreground antialiased">
          <Navbar />
          <FloatingPortalButton />
          <main>
            <Hero />
            <Services />
            <About />
            <Certificates />
            <ServiceAreas />
            <Contact />
          </main>
          <Footer />
        </div>
      </SmoothScroll>
    </SiteProvider>
  );
}

export default App;
